import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_cancellation_request';
export const route = 'membership_cancellation_request/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipcancellationrequest" */
'../../components/MembershipCancellationRequest')));